import React, { useState } from 'react'
import styles from './knows.module.css'

const Environment = () => {
  const [hide, setHide] = useState(styles.hide);
  const [arrowDirection, setArrowDirection] = useState(styles.right);
  const handleClick = event => {
    if(hide == ""){
      setHide(styles.hide);
    } else {
      setHide("");
    }
    if(arrowDirection == styles.right){
      setArrowDirection(styles.down);
    } else {
      setArrowDirection(styles.right);
    }
  };

  return(
    <div className={styles.environment}>
      <div className={[styles.title, styles.hand].join(' ')} onClick={handleClick}>KNOW Your Environment <i className={[styles.arrow, arrowDirection].join(' ')}></i> </div>
      <div className={[styles.body, hide].join(' ')}>
        <ul className={styles.listTitle}>
          <li className={styles.listItem}>Indoor/Outdoor</li>
          <li className={styles.listItem}>Electricity</li>
          <li className={styles.listItem}>Windows & Lighting</li>
          <li className={styles.listItem}>Projectors</li>
          <li className={styles.listItem}>Computers</li>
          <li className={styles.listItem}>Internet</li>
          <li className={styles.listItem}>Sound System - microphones</li>
          <li className={styles.listItem}>Podiums</li>
          <li className={styles.listItem}>Stages</li>
        </ul>
      </div>
    </div>
  )
}

export default Environment
